<div class="container-fluid webView" style="padding-left: 10px;">
    <!-- Header -->
    <!-- <div class="col-12 col-sm-12 bgWhite webView"> -->
    <div class="col-12 col-sm-12 bgWhite webView" style="padding: {{expensemodalshow == true ? '15px 0px 0px 0px' : '15px 15px 0px 15px' }};">

        <div class="col-5 col-sm-5" style="padding: 0px; display: inline-block;vertical-align: middle;">
            <h3 class="newHeader" style="display: inline-block; font-size: 25px;">
                Project Expense Types
            </h3>          
        </div>

        <div class="col-md-7 col-sm-7" style="display: inline-block; text-align: right; padding: 0px;">
            <span *ngIf="expensemodalshow">
                <span class="lableBtnOrange brdrRadius3" (click)="open(Addexpense,0)" title="Add New Stage"
                    style="position: relative; top: 0px; cursor: pointer; bottom: 5px; padding: 9px; font-size: 11px; margin-right: 5px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
            </span>
            <span *ngIf="expensemodalshow" class="closeMdl ng-scope" style="margin-right: 0%; padding: 5px 10px !important;"
                (click)="closeModel()">
                <i class="zmdi zmdi-close" title="Close" style="cursor:pointer;  position: relative; top: 0.5px;"></i>
            </span>          
        

            <span *ngIf="!expensemodalshow && costTypeList.length > 0" class="btn btn-orange brdrRadius3" (click)="open(Addexpense,0)" title="Add New Expense Type"
                style="padding:4px 10px;font-size:13px;line-height: 19px; height: 30px;">
                    <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                    <span> Add</span>
                </span>

            <span  *ngIf="!expensemodalshow" class="darkBlueButton" style="margin-left: 10px; font-size: 13px; display: inline-block; padding:4px 12px 4px; cursor: pointer;" (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 3px; vertical-align: middle;"></i> Return to Settings
            </span>
        </div>
    </div>

    <!-- show Expenses List -->
    <div class="col-md-12" style="padding: {{expensemodalshow == true ? '0px' : '0px 15px' }};">
        <!-- Right -->
        <div class="col-md-12" style="padding: 15px 0px;">
            <!-- Right -->
            <div class="{{expensemodalshow == true ? 'col-md-12' : 'col-md-5' }} mainCardHeader inLneBlk" style="padding: 0px; vertical-align:middle;overflow: auto; height: {{expensemodalshow ? '400px' : ''}};">
                <div id="divScrID" class="col-md-12" style="padding: 0px;">
                    <div *ngFor="let e of costTypeList let i = index"
                        class="col-md-12 lableBtnOrange brdrRadius3"
                        style="margin-bottom: 10px; background-color:white; text-align: left; padding: 6px 15px; color: #e88421; border: 1px solid #e88421;">
                        <div class="row">
                            <div class="col-8">
                                <span style="font-size: 14px;">{{e.CNm}}</span>
                            </div>
                            <div class="col-4" style="text-align: right;display: inline-block;">                              
                                <div class="lableBtnGray" style="display: inline-block;cursor: pointer;font-size: 13px;" title="Delete Expense" (click)="deleteExpense(e)">
                                    <i class="fa fa-trash"></i>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <div style="margin-top: 15px;">
                  <span *ngIf="!expensemodalshow && costTypeList.length > 0" class="btn orangeButton brdrRadius3" (click)="open(Addexpense,0)" title="Add New Stage"
                    style="padding:4px 12px 4px;font-size:13px;line-height: 18px; height: 30px;">
                        <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                        <span> Add</span>
                    </span>  
				</div>
                <div class="bgWhite brdrRadius3" style="padding-top: 15px;cursor:pointer;" *ngIf="costTypeList.length == 0">                   
					 <div class="nrf brdrRadius3" (click)="open(Addexpense,0)">
                        Click here to add an Expense Type.
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- <div *ngIf="costTypeList.length > 0" class="col-md-12 col-12 col-sm-12 leftPad mobView">
    <div class="col-md-5 col-12 col-sm-12" style="padding: 0px;">
        <div  *ngFor="let e of costTypeList let i = index" class="col-md-12 col-12 col-sm-12 {{i == '0' ? 'orangeBadge' : i == '1' ? 'yellowBadge' :  i == '2' ? 'greenBadge' : i == '3' ? 'tealBadge' : i == '4' ? 'blueBadge' : i == '5' ? 'darkBlueBadge' : i == '6' ? 'brownBadge' :  i == '7' ? 'orangeBadge' : i == '8' ? 'yellowBadge' : i == '9' ? 'greenBadge': i == '10' ? 'tealBadge' : i == '11' ? 'blueBadge' :  i == '12' ? 'darkBlueBadge' : i == '13' ? 'brownBadge' : i == '14' ? 'orangeBadge' : i == '15' ? 'yellowBadge' : i == '16' ? 'greenBadge' :  i == '17' ? 'tealBadge' : i == '18' ? 'blueBadge' : i == '19' ? 'darkBlueBadge':'yeloowBadge'}}" style="padding-top: 10px; 
        padding-bottom: 10px;margin-bottom: 5px;border-radius: 0px;display:inline-flex">
            <div class="col-md-9 col-9 col-sm-9" style="font-size: 13px;display: inline-block;padding: 0px;">
            <span>{{e.CNm}}</span>
            </div>
            <div class="col-3 col-sm-3" style="text-align: right;display: inline-block;">
                <div style="border-radius: 50%; margin-right: 15px; font-size: 13px; display: inline-block; cursor: pointer;" title="Edit" (click)="open(mymodal,r.RID)">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                </div> 
                <div style="border-radius: 50%; display: inline-block;cursor: pointer;font-size: 13px;" title="Delete" (click)="deleteReason(i)">
                    <i class="fa fa-trash"></i>
                </div>                                  
            </div>
        </div>
    </div> 
</div> -->

<div class="mobView pad0" style="background: white;">
        <!-- Header -->
    <div class="col-md-12 bgWhite padHeder">
        <div class="col-md-12 col-12 col-sm-12 inLneBlk" style="padding-left: 0px; padding-right: 0px;">
        <span style="font-size: 20px; margin-right: 10px;" (click)="backBtn()">
            <i class="fa fa-chevron-left"></i>
        </span>
        <h4 class="newHeader" style="display: inline-block; padding-top: 6px;">Expense Types</h4>
        <span class="text-right">
            <span class="label brdrRadius3" (click)="open(Addexpense,0)"style="float: right;top: 8px; right: 0px; position: relative; cursor: pointer; padding: 4px 9px; font-size: 14px; background: #e88421 !important; color: #fff !important ">
            <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
            <span> Add</span>
            </span>
        </span>
        </div>
    </div>

    <!-- Body -->
    <div class="col-md-12" style="padding: 0px;">
      <!-- Right -->
      <div class="col-md-6 mainCardHeader inLneBlk" style="padding: 0px; vertical-align: top;">
        <div cdkDropList id="divScrID" class="col-md-12">
            <div *ngIf="costTypeList.length > 0" class="col-md-12 col-12 col-sm-12 leftPad mobView">
                <div class="col-md-5 col-12 col-sm-12" style="padding: 0px;">
                    <div  *ngFor="let e of costTypeList let i = index" class="col-md-12 col-12 col-sm-12 orangeBadge bgWhite brdrRadius3 orangeBrdr" style="padding-top: 10px; 
                    padding-bottom: 10px;margin-bottom: 8px;display:inline-flex; background-color: #fff !important;">
                        <div class="col-md-9 col-9 col-sm-9" style="font-size: 13px;display: inline-block;padding: 0px;">
                        <span>{{e.CNm}}</span>
                        </div>
                        <div class="col-3 col-sm-3" style="text-align: right;display: inline-block; padding:0px;">
                          
                            <div style="border-radius: 50%; display: inline-block;cursor: pointer;font-size: 13px;" title="Delete" (click)="deleteExpense(e)">
                                <i class="fa fa-trash"></i>
                            </div>                                  
                        </div>
                    </div>
                </div> 
            </div>
        </div>
        
        <div class="bgWhite" style="padding-top: 15px;" *ngIf="costTypeList.length == 0">
          <div class="nrf brdrRadius3" (click)="open(Addexpense,0)" style="margin-left: 15px;">
            Click here to add an Expense Type.
          </div>
        </div>
      </div>
    </div>

</div>


    <!--Add stage-->
<ng-template #Addexpense let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title">
                        <span id="ApntmntHdr" style="font-size: 20px;">Expense Type</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close " title="Close" style="float: right;" (click)="closeModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12" style="padding: 10px 15px 15px 15px;">
            <div class="col-md-12 col-xs-12 col-12" style="padding: 0px;">
                <input type="text" class="form-control fn13 formCtlFltr" [(ngModel)]="newExpense.expenseName" maxlength="50"
                    style="text-indent: 2px; " placeholder="Enter Expense Type" captalize-first>
            </div>
        </div>
        <div class="col-md-12">
            <div class="col-md-6 col-6" *ngFor="let u of rights let i = index"
                style="display: inline-block; margin-bottom: 10px;padding: 5px; font-size: 13px;">
                <!-- <input type="checkbox" [disabled]="u.IsDisabled" [(ngModel)]="u.isChecked" style="vertical-align: middle;">
                <span style="margin-left: 5px;">{{u.Name}}</span> -->
                 <label style="margin-left: 5px; cursor: pointer;">
                    <input type="checkbox" [disabled]="u.IsDisabled" [(ngModel)]="u.isChecked" 
                    style="cursor: pointer; margin-right: 5px; position: relative; top: 2px;">{{u.Name}}
                </label> 
            </div>
            
        </div>
        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px;">
            <span class="btn btn-darkGreen brdrRadius3" style="padding:  2px 8px;line-height: 23px;font-size: 13px;" (click)="addExpense(newExpense.expenseName)">
                <i class="fa fa-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>
        </div>
    </div>
</ng-template>


